import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { DocumentNumberInput } from '@/components/document-number-input'
import { GroupInput } from '@/components/v2/group-input'
import { CompanySelector, ManagmentSelector, OfficeSelector } from '@/shared/selectors'
import { InputHelperText } from '@/shared/components/input-helper-text'
import PropTypes from 'prop-types'

export const UserCompanyInformationForm = (props) => {
  const { company = {} } = props
  const { values, setFieldValue, errors } = useFormikContext()
  const { t } = useTranslation()

  const onChangeCompany = (option = {}) => {
    if (!option?.value) {
      setFieldValue('resource_type', '')
      setFieldValue('resource_id', '')
      return
    }

    setFieldValue('resource_type', 'Contractor::Company')
    setFieldValue('resource_id', option.value)
  }

  return (
    <GroupInput
      title='Datos de la empresa'
      description='Rellena la información de la empresa a la que pertenece el usuario'
      divider={false}
      className='py-8'
    >
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <CompanySelector
            onChange={onChangeCompany}
            value={values.resource_id}
          />
          <InputHelperText color='red' label={errors?.resource_id} />
        </div>
        <DocumentNumberInput
          label={t('documentNumber.one')}
          value={company.documentNumber}
          readOnly
        />
        <div className='col-span-2'>
          <div className='grid grid-cols-2 gap-4'>
            <ManagmentSelector
              isClearable
              onChange={(option = {}) =>
                setFieldValue('account_managment_id', option?.value || null)
              }
              value={values.account_managment_id}
            />
          </div>
          <InputHelperText color='red' label={errors.account_managment_id} />
        </div>

        <div>
          <OfficeSelector
            isClearable
            value={values.account_office_id}
            onChange={(option = {}) =>
              setFieldValue('account_office_id', option?.value || null)
            }
          />
          <InputHelperText label={errors.account_office_id} color='red' />
        </div>
      </div>
    </GroupInput>

  )
}

UserCompanyInformationForm.propTypes = {
  company: PropTypes.object
}
